export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';

export const NOTIFICATION_RECIEVED = 'NOTIFICATION_RECIEVED';

export const MARK_NOTIFICATION_AS_READ_REQUEST = 'MARK_NOTIFICATION_AS_READ_REQUEST';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_FAILURE = 'MARK_NOTIFICATION_AS_READ_FAILURE';

export const SEE_MORE_NOTIFICATIONS = 'SEE_MORE_NOTIFICATIONS';

export const RESET_UNREAD_COUNT = 'RESET_UNREAD_COUNT';

export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS';
export const SET_CHAT_UNREAD_COUNT = 'SET_CHAT_UNREAD_COUNT';
